import { render, staticRenderFns } from "./ShippingCost.vue?vue&type=template&id=debe8620&scoped=true"
import script from "./ShippingCost.vue?vue&type=script&lang=js"
export * from "./ShippingCost.vue?vue&type=script&lang=js"
import style0 from "./ShippingCost.vue?vue&type=style&index=0&id=debe8620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debe8620",
  null
  
)

export default component.exports